<template>
  <div>
    <BaseModalLayout ref="msg" hide-cancel modal-size="md" />
    <h4>Manage Files</h4>
    <div class="muted small">
      You can upload up to 5 project files of size maximum 50MB each.
    </div>
    <div class="muted small">
      Supported files are *.csv and Microsoft Excel files.
    </div>
    <b-row class="my-3">
      <b-col cols="12">
        <div class="d-block mb-2">
          <div>
            <b-form-file
              id="signed-file"
              ref="fileinput"
              v-model="signedFile"
              class="d-none"
              :validate="'required'"
              accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
              multiple
              drop-placeholder="Drop file here..."
            ></b-form-file>
            <b-button
              :disabled="disableAddFile"
              variant="primary"
              class="addBtn"
              @click="addFile"
            >
              <BaseIcon name="plus" style="color: white" class="mr-2" />
              Add File(s)
            </b-button>

            <div class="border-bottom mt-3" />
          </div>
        </div>
      </b-col>
    </b-row>

    <b-row class="mt-3">
      <b-col>
        <h6 class="muted">
          Upload Pending/InProgress - ({{ pendingFiles.length }}) File(s)
        </h6>
        <b-row class="small">
          <b-col class="">Files Uploaded: {{ filesUploadedList.length }}</b-col>
          <b-col class="">Upload In Progress: {{ upCount }} File(s)</b-col>
          <b-col class="">Remaining Allowed: {{ alCount }} File(s)</b-col>
        </b-row>
        <b-list-group v-if="pendingFiles && pendingFiles.length > 0">
          <b-list-group-item
            v-for="(b, bi) in pendingFiles"
            :key="bi"
            class="border-0"
          >
            <div class="d-flex bd-highlight">
              <div class="p-2 bd-highlight mr-2">
                <BaseIcon name="file-excel" style="font-size: 2.5rem;" />
              </div>
              <div class="p-2 flex-grow-1 bd-highlight">
                <BaseELabel :label="b.fileName" size="md" />
                <b-row class="py-0 my-0 small">
                  <b-col class="muted py-0 my-0">
                    Status: {{ b.message || 'Pending upload' }}
                    <b-progress
                      v-if="b.isShowProgress"
                      value="100"
                      max="100"
                      animated
                      height="0.6rem"
                    ></b-progress>
                  </b-col>
                  <b-col class="muted">
                    Size: {{ sizeMB(b.fileSize) }} MB
                  </b-col>
                  <b-col class="muted">
                    {{ b.comment }}
                  </b-col>
                </b-row>
              </div>
              <div class="p-2 bd-highlight">
                <BaseEButton
                  icon="trash"
                  variant="icon"
                  :disabled="b.isbusy"
                  @click="() => removePendingFile(b)"
                />
                <BaseEButton
                  icon="upload"
                  variant="icon"
                  :disabled="b.isbusy"
                  @click="() => doUpload(b)"
                />
              </div>
            </div>
          </b-list-group-item>
          <!-- <b-list-group-item>Dapibus ac facilisis in</b-list-group-item>
            <b-list-group-item>Morbi leo risus</b-list-group-item>
            <b-list-group-item disabled>Porta ac consectetur ac</b-list-group-item>
            <b-list-group-item>Vestibulum at eros</b-list-group-item> -->
        </b-list-group>
        <span v-else><b> ---</b></span>
      </b-col>
    </b-row>

    <b-row class="mt-5">
      <b-col cols="12">
        <h6 class="muted"
          >Upload Errors - ({{ filesErrorList.length }}) File(s)</h6
        >
        <p class="small"
          >Following files and all their contents are not processed due to
          validation errors.</p
        >
        <b-list-group v-if="filesErrorList && filesErrorList.length > 0">
          <b-list-group-item
            v-for="(b, bi) in filesErrorList"
            :key="bi"
            class="border-0"
          >
            <div class="d-flex bd-highlight">
              <div class="p-2 bd-highlight mr-2">
                <BaseIcon name="file-excel" style="font-size: 2.5rem;" />
              </div>
              <div class="p-2 flex-grow-1 bd-highlight">
                <BaseELabel :label="b.fileName" size="md" />
                <b-row class="py-0 my-0 small">
                  <b-col class="muted py-0 my-0">
                    Size: {{ sizeMB(b.fileSize) }} MB
                  </b-col>
                </b-row>
              </div>
              <!-- <div class="p-2 bd-highlight">
                  <BaseEButton icon="trash" variant="icon" @click="() => removeErrorFile(b)"/>
                </div> -->
            </div>
            <div class="error">
              <ul>
                <li class="text-break">
                  {{ b.errorDetails }}
                </li>
              </ul>
            </div>
          </b-list-group-item>
        </b-list-group>
        <span v-else> <b> ---</b></span>
      </b-col>
    </b-row>

    <b-row class="mt-5">
      <b-col>
        <h6 class="muted">
          Upload Completed - ({{ filesUploadedList.length }}) File(s)
        </h6>
        <b-table-simple responsive hover>
          <thead>
            <b-tr>
              <b-th>File #</b-th>
              <b-th>File Description</b-th>
              <b-th>Import Error(s)</b-th>
              <b-th>Rule Engine Execution</b-th>
            </b-tr>
          </thead>
          <tbody>
            <b-tr v-for="(b, bi) in filesUploadedList" :key="bi">
              <b-td class="py-2">
                {{ bi + 1 }}
              </b-td>
              <b-td class="py-2">
                <div class="row py-0 my-0">
                  <b-col class="py-0 my-0">
                    <BaseELabel :label="b.fileName" size="md" />
                  </b-col>
                </div>

                <b-row class="py-0 my-0">
                  <b-col class="muted py-0 my-0">
                    Size: {{ sizeMB(b.fileSize) }} MB
                  </b-col>
                  <b-col class="muted">
                    Records: {{ b.numberOfRecordsUploaded }}
                  </b-col>
                  <b-col class="muted">
                    Modified: {{ b.lastModifiedDate }}
                  </b-col>
                  <b-col class="muted">
                    {{ b.comment }}
                  </b-col>
                </b-row>
              </b-td>
              <b-td class="py-2">
                <b-link
                  v-if="b.isErrors"
                  @click="() => showErrorSummaryModal(b)"
                >
                  View Error
                </b-link>
              </b-td>
              <b-td class="py-2">
                {{ getRuleEngineStatus(b.ruleExecStatus) }}
              </b-td>
            </b-tr>
          </tbody>
        </b-table-simple>
      </b-col>
    </b-row>

    <b-modal
      id="bv-modal-errorview"
      ref="errorview"
      size="xl"
      hide-footer
      title="Error Summary"
    >
      <BaseSpinner v-if="showSpinner" />
      <h6>Showing Records with error(s)</h6>
      <BaseDataTable
        ref="tableErrorLoans"
        :options="errorOptions"
        :commands="commands"
        :items="viewErrorsList"
        :fields="fieldsErrors"
        :current-page="currentPage"
        :per-page="perPage"
        :total-rows="rows"
        data-table-selectable
        control-row-selection
        showdatatablefooter
        @onRowSelected="onRowSelected"
        @rowPerPageChange="rowPerPageCount"
        @paginationEvent="paginationEvent"
        @onCommandEvent="onCommandEvent"
        @sortingChanged="sortingChanged"
      />
      <!-- control-row-select will ensure that rows with propertyes isSelectEnable false cannot be selected -->
      <b-row class="mt-3 pt-3 justify-content-center" align="center">
        <b-col>
          <h4 class="muted"
            >Choose what actions to perform on the duplicate records</h4
          >
        </b-col>
      </b-row>
      <b-row class="mt-4 justify-content-center" align="center">
        <b-col vertical-align="center">
          <BaseEButton
            :disabled="errSelCount < 1"
            @click="duplicateLoansActionClick(ignore)"
            >Ignore Selected Records</BaseEButton
          >
          <p class="muted small pt-3 px-2">
            Choosing this option will mark all selected records as void. They
            will no longer be updated further. All Existing records will remain
            AS IS.
          </p>
        </b-col>
        <b-col vertical-align="center">
          <BaseEButton
            :disabled="errSelCount < 1"
            @click="duplicateLoansActionClick(overwrite)"
            >Overwrite Selected Records</BaseEButton
          >
          <p class="muted small pt-3 px-3">
            Choosing this option will add all selected records in this project.
            All previously saved records (in this project or outside) will be
            marked void.
          </p>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>
<style lang="scss" scoped>
@import '@design';
.muted {
  display: block;
  color: #8c8f8f;
}

.addBtn {
  &:disabled {
    cursor: not-allowed;
    background: $color-button-disabled-bg;
  }
}
</style>
<script>
import {
  hmdaMethods,
  hmdaGetters,
  toasterMethods,
  broadcastGetters,
} from '@state/helpers'
import constant from '@constants/constant'

const EventCodes = {
  download_csv: 1,
}

export default {
  props: {
    // projectDetails: { type: Object, default: () => {} },
    // uploadedFiles: { type: Array, default: () => [] },
  },
  data() {
    return {
      errSelCount: 0,
      acceptedExtensions: ['.csv', '.xls', '.xlsx'],
      options: [15, 30],
      thisErrorsList: [],
      commands: [
        {
          text: 'Download CSV',
          event: EventCodes.download_csv,
          icon: 'download',
          tooltip: 'Download this list in CSV Format',
        },
      ],
      signedFile: [],
      errorFiles: [],
      pendingFiles: [],
      projectDetail: {},
      fieldsErrors: [
        {
          key: 'customselect',
          label: 'Select',
          sortable: false,
          class: 'text-center',
        },
        {
          key: 'loanNumber',
          label: 'Loan Number',
          sortable: false,
          class: 'text-left',
        },
        {
          key: 'uli',
          label: 'ULI',
          sortable: true,
          class: 'text-left',
        },
        {
          key: 'refItemList',
          label: 'Error Message',
          refValField: 'errorMessage',
          sortable: true,
          class: 'text-left',
        },
      ],
      errorOptions: [5, 10, 15, 20, 25],
      viewErrorsList: [],
      rows: 0,
      perPage: 5,
      currentPage: 1,
      showSpinner: false,
      larFileId: 0,
      larFileName: 0,
      ignore: 1,
      overwrite: 2,
      sortByColoumn: '',
      sortByDirection: 0,
      recentFielsData: null,
      // enableAutoUpdate: true,
      tempPendingFile: [],
      summaryPollingInterval: null,
    }
  },
  computed: {
    ...broadcastGetters,
    ...hmdaGetters,
    PROJECT_ID() {
      return this.$route.params.id || '0'
    },

    disableAddFile() {
      return (
        this.alCount < 1 ||
        this.projectSummary.status ===
          constant.hmdaProjectStatus.completed.value
      )
    },
    upCount() {
      return this.pendingFiles ? this.pendingFiles.length : 0
    },
    alCount() {
      return 5 - this.filesUploadedList.length - this.upCount
    },

    filesList() {
      return this.$store.state.hmdaModule.filesList
    },
  },
  watch: {
    // clear pending files based on updates
    filesErrorList() {
      if(this.filesErrorList.length) {
        let ind = null
        this.filesErrorList.map((f) => {
          this.tempPendingFile.map((t, i) => {
            if(f.fileName === t.fileName) {
              ind = i
            }
          })
        })
        if(ind !== null) {
          this.tempPendingFile.splice(ind, 1)
        }
      }
    },
    filesUploadedList() {
      if(this.filesUploadedList.length) {
        let ind = null
        let fobj = null
        this.filesUploadedList.map((t) => {
          this.pendingFiles.map((p, i) => {
            if(p.fileName === t.fileName) {
              ind = i
              fobj = p
            }
          })
        })
        if(ind !== null) {
          this.pendingFiles.splice(ind, 1)
        }
        if(fobj) {
          let index = this.tempPendingFile.indexOf(fobj) || null
          if(index !== null) {
            this.tempPendingFile.splice(index, 1)
          }
        }
      }
    },
    signedFile(f) {
      if (f && f.length) this.fileChanged(f)
    },
    messageTypeFileUpload(n) {
      this.processUploadMessage(n)
    },
  },
  created() {
    this.summaryPollingInterval = constant.hmdaSummaryPollingInterval || 59999
    this.autoManageFilesData()
  },
  mounted() {
    this.loadProjectFiles()
    // this.viewError()
  },
  beforeDestroy() {
    clearInterval(this.recentFielsData)
  },

  methods: {
    ...hmdaMethods,
    ...toasterMethods,
    autoManageFilesData() {
      if(this.summaryPollingInterval) {
        this.recentFielsData = setInterval(function(){
        // configure 1 minute update interval
        this.getRecentData()}.bind(this), this.summaryPollingInterval)
      }
    },
    getRuleEngineStatus(status) {
      let statusText = null
      switch(status){
        case 0: statusText = 'Failed'
          break
        case 1: statusText = 'Completed'
          break
        case 3: statusText = 'In Progress'
          break
        case 4: statusText = ' '
          break
      }
      return statusText
    },
    getRecentData() {
      this.loadProjectFiles()
    },
    loadProjectFiles() {
      return this.fetchProjectFiles({
        projectId: this.PROJECT_ID,
      }).then((response) => {
        this.pendingFiles = response.data
          ? response.data.inProgressFiles || []
          : []
        this.pendingFiles.forEach((f) => {
          f.isShowProgress = true
          f.message = 'File processing in progress...'
          f.isbusy = true
        })
        // retain temp stack of pending files during dynamic data updates
        if(this.tempPendingFile.length) {
          this.tempPendingFile.map((fl) => {
            let canPushFile = true
            this.pendingFiles.map((p) => {
              if(p.fileName === fl.fileName) {
                canPushFile = false
              }
            })
            if(canPushFile) {
              this.pendingFiles.push(fl)
            }
          })
        }
      })
    },
    clickIgnoreRecords() {
    },
    onRowSelected(rows) {
      this.errSelCount = rows.length
    },
    sizeMB(size) {
      return (size / 1024 / 1024).toFixed(2)
    },
    removeErrorFile(item) {
      let idx = this.errorFiles.indexOf(item)
      if (idx > -1) {
        this.errorFiles.splice(idx, 1)
      }
    },
    removePendingFile(item) {
      let idx = this.pendingFiles.indexOf(item)
      if (idx > -1) {
        this.pendingFiles.splice(idx, 1)
        if(this.tempPendingFile.length) {
          const ind = this.tempPendingFile.indexOf(item)
          this.tempPendingFile.splice(ind, 1)
        }
      }
    },
    // async viewError(item) {
    //   let b = item.errors
    //   console.log(b)
    //   b.forEach((p) => { p.errorMessage = 'Duplicate' })
    //   this.thisErrorsList = b

    //   this.$bvModal.show('bv-modal-errorview')

    // },
    async doUpload(item) {
      const isFileSize = item.size / 1024 ** 2
      if (isFileSize > 50) {
        this.setAlert({
          title: constant.imageHeaderError,
          msg: `The file size cannot be more than 50MB`,
          variant: constant.errorMessagetype,
        })
        return
      }
      item.status = 'uploading'
      item.message = 'Uploading...'
      item.isbusy = true
      item.isShowProgress = true

      this.uploadLoanFiles({
        file: item.file,
        projectId: this.PROJECT_ID,
      }).then((resp) => {
        if (resp.isSuccess === true) {
          item.message = 'File processing in progress...'
          this.$forceUpdate()
        } else if (resp.isSuccess === false) {
          item.message = 'Upload failed - File already exists'
          item.isbusy = false
          item.isShowProgress = false
        } else {
          item.message = 'Upload failed'
          item.isbusy = false
          item.isShowProgress = false
        }
      }).catch((err) => {
          this.authError = err
          if(this.filesUploadedList.length || this.filesErrorList.length) {
            this.setAlert({
              title: constant.imageHeaderError,
              msg: `File already exists: ${item.fileName}`,
              variant: constant.errorMessagetype,
            })
          }
        // remove from pending stack
          if(this.pendingFiles.length && this.filesUploadedList.length) {

            let index = null
            this.pendingFiles.map((p, pi) => {
              if(p.fileName === item.fileName) {
                index = pi
              }
            })
            if(index !== null) {
              this.pendingFiles.splice(index, 1)
            }
            // clear temp stack files also.
            let tIndex = null
            this.tempPendingFile.map((p, ti) => {
              if(p.fileName === item.fileName) {
                tIndex = ti
              }
            })
            if(tIndex !== null) {
              this.tempPendingFile.splice(tIndex, 1)
            }
          }
        })
      // this.enableAutoUpdate = true
    },

    async deleteContainer() {
      await this.$store.dispatch('hmdaModule/deleteContainer')
    },

    async createContainer() {
      await this.$store.dispatch('hmdaModule/createContainer')
    },

    async getFilesList() {
      await this.$store.dispatch('hmdaModule/getBlobsInContainer')
    },

    processUploadMessage(message) {

      // // todelete
      // let message = Object.assign({}, msg, {
      //   ProjectId: this.PROJECT_ID,
      // })

      // if notification is for the same project id, just reload the project files
      if (Number(message.ProjectId) === Number(this.PROJECT_ID)) {
        this.loadProjectFiles().then((l) => {
          let index = this.pendingFiles.findIndex((i) =>
            (i.FileName || '')
              .toLowerCase()
              .includes(message.FileName.toLowerCase())
          )

          if (index > -1) {
            this.removePendingFile(this.pendingFiles[index])
          }
        })
      }
    },

    addFile() {
      this.$refs.fileinput.$refs.input.click()
    },
    fileChanged(f) {
      // add the files to the UI pending list
      ;(f || []).map((a) => {
        if (!this.pendingFiles.find((x) => x.fileName === a.name)) {
          this.acceptedExtensions.forEach((ext) => {
            if (a.name && a.name.endsWith(ext)) {
              this.pendingFiles.push({
                file: a,
                fileName: a.name,
                fileSize: a.size,
                fileCount: 0,
                errors: [],
                status: 'Pending Upload',
                isbusy: false,
              })
              this.tempPendingFile.push(this.pendingFiles.slice(-1)[0])
            }
          })
        }
      })

      // clear the input element files so new files can be added
      this.$refs.fileinput.reset()
    },

    showErrorSummaryModal(item) {
      this.$bvModal.show('bv-modal-errorview')
      this.larFileId = item.fileId
      this.larFileName = item.fileName
      this.viewError()
    },

    viewError() {
      this.showSpinner = true
      this.fetchUploadedFilesErrorList({
        Payload: {
          pageSize: this.perPage,
          pageNumber: this.currentPage,
          sortBy: this.sortByColoumn,
          sortDirection: this.sortByDirection,
        },
        LarId: this.larFileId,
      })
        .then((response) => {
          let errors = response ? response.data.larErrors || [] : []
          errors.forEach((e) => {
            // e.disableSelect = !(e.isSelectEnable === undefined  || e.isSelectEnable)
            e.disableSelect = e.isSelectEnable || e.isLarSummaryGenerated
            e.errorMessage =
              e.projectNames && e.projectNames.length
                ? e.projectNames
                : e.errorMessage
          })

          this.viewErrorsList = errors
          this.rows = response.data.totalCount
          this.currentPage = this.currentPage
          this.showSpinner = false
        })
        .catch(() => {
          this.showSpinner = false
        })
    },

    paginationEvent(currentPage) {
      if (this.currentPage !== currentPage) {
        this.currentPage = currentPage
        this.viewError()
      }
    },

    rowPerPageCount(pageValue) {
      this.perPage = parseInt(pageValue)
      this.currentPage = 1
      if (this.rows !== 0) {
        this.viewError()
      }
    },

    duplicateLoansActionClick(action) {
      this.showSpinner = true
      let larDetailsIds = []
      const selectedRecords = this.$refs.tableErrorLoans.getSelectedRecords()
      selectedRecords.forEach((record) => {
        larDetailsIds.push(record.larDetailsId)
      })
      this.actionOnDuplicateLoans({
        Payload: {
          larId: this.larFileId,
          larDetailsIds: larDetailsIds,
          processFile: action,
        },
      })
        .then((response) => {
          this.viewError()
          this.showSpinner = false
        })
        .catch(() => {
          this.showSpinner = false
        })
    },

    downloadErrorsCsvFile() {
      this.downloadErrorListCsv({
        LarFileId: this.larFileId,
      })
        .then((response) => {
          const fileName = this.larFileName
          let csvName = `${fileName.substring(
            0,
            fileName.lastIndexOf('.')
          )}_Error.csv`
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            var CSV = response.data
            var fullTemplate = [CSV]
            var blob1 = new Blob(fullTemplate, { type: 'text/html' })
            window.navigator.msSaveOrOpenBlob(blob1, csvName)
          } else {
            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', csvName)
            document.body.appendChild(link)
            link.click()
          }
        })
        .catch((error) => {
          return error
        })
    },

    onCommandEvent(command) {
      switch (command) {
        case EventCodes.download_csv:
          this.downloadErrorsCsvFile()
          break
      }
    },

    sortingChanged(ctx) {
      if (ctx.sortBy !== null && ctx.sortBy !== '') {
        let sortBy = ''
        if (ctx.sortBy === 'errorMessage') sortBy = 'errormessage'
        else if (ctx.sortBy === 'uli') sortBy = 'uli'
        this.sortByColoumn = sortBy
        this.sortByDirection = ctx.sortDesc ? 1 : 0
        this.viewError()
      }
    },
  },
}
</script>
